var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkTriangle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.295 4L.272 7.464V.536L5.295 4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTriangle);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg viewBox='0 0 6 8' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M5.29492 4L0.271627 7.4641L0.271627 0.535898L5.29492 4Z'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };